import { render, staticRenderFns } from "./Amap.vue?vue&type=template&id=08a65d0c&scoped=true"
import script from "./Amap.vue?vue&type=script&lang=js"
export * from "./Amap.vue?vue&type=script&lang=js"
import style0 from "./Amap.vue?vue&type=style&index=0&id=08a65d0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08a65d0c",
  null
  
)

export default component.exports